export default __webpack_public_path__ + "static/pragicts-automation-banner-human-error-d2b578ceafca047122c47325af735064.jpg";